import { Readability } from '@mozilla/readability';

(function () {
  var btn = document.querySelector('.jsReaderMode');
  if (!btn) return;

  var FONT_SIZES = [16, 18, 20, 22, 24];
  var DEFAULT_SIZE_INDEX = 1;

  function getStoredFontSize() {
    var stored = localStorage.getItem('readerFontSize');
    var idx = stored !== null ? parseInt(stored, 10) : DEFAULT_SIZE_INDEX;
    return idx >= 0 && idx < FONT_SIZES.length ? idx : DEFAULT_SIZE_INDEX;
  }

  function createOverlay(parsed) {
    var sizeIndex = getStoredFontSize();

    // Post meta from the page
    var authorEl = document.querySelector('.c-post__meta-author');
    var timeEl = document.querySelector('.c-post__meta-time');
    var authorText = authorEl ? authorEl.textContent.trim() : '';
    var timeText = timeEl ? timeEl.textContent.trim() : '';

    var overlay = document.createElement('div');
    overlay.id = 'reader-mode-overlay';
    overlay.className = 'c-reader';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Reader Mode');

    overlay.innerHTML =
      '<div class="c-reader__toolbar">' +
        '<div class="c-reader__toolbar-inner">' +
          '<button class="c-reader__close jsReaderClose" aria-label="Close reader mode">' +
            '<i class="fas fa-times"></i>' +
          '</button>' +
          '<div class="c-reader__font-controls">' +
            '<button class="c-reader__font-btn jsReaderFontDecrease" aria-label="Decrease font size">' +
              '<i class="fas fa-minus"></i>' +
            '</button>' +
            '<span class="c-reader__font-label">Aa</span>' +
            '<button class="c-reader__font-btn jsReaderFontIncrease" aria-label="Increase font size">' +
              '<i class="fas fa-plus"></i>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="c-reader__body">' +
        '<article class="c-reader__article">' +
          '<h1 class="c-reader__title">' + escapeHtml(parsed.title) + '</h1>' +
          '<div class="c-reader__meta">' +
            (authorText ? '<span class="c-reader__author">' + escapeHtml(authorText) + '</span>' : '') +
            (timeText ? '<time class="c-reader__time">' + escapeHtml(timeText) + '</time>' : '') +
          '</div>' +
          '<div class="c-reader__content">' + parsed.content + '</div>' +
        '</article>' +
      '</div>';

    updateFontSize(overlay, sizeIndex);
    return overlay;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function updateFontSize(overlay, sizeIndex) {
    var content = overlay.querySelector('.c-reader__content');
    if (content) {
      content.style.fontSize = FONT_SIZES[sizeIndex] + 'px';
    }
    localStorage.setItem('readerFontSize', sizeIndex);
  }

  function open() {
    // Clone the post content into a standalone document for Readability
    var postContent = document.querySelector('.c-post__content.c-entry');
    var postTitle = document.querySelector('.c-post__header-title');
    if (!postContent) return;

    var titleText = postTitle ? postTitle.textContent.trim() : document.title;
    var doc = document.implementation.createHTMLDocument(titleText);

    // Create an article wrapper for Readability to find
    var article = doc.createElement('article');
    article.innerHTML = '<h1>' + escapeHtml(titleText) + '</h1>' + postContent.innerHTML;
    doc.body.appendChild(article);

    var parsed = new Readability(doc).parse();
    if (!parsed) return;

    // Use original title if Readability didn't extract a good one
    if (!parsed.title) parsed.title = titleText;

    var overlay = createOverlay(parsed);
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';

    // Force reflow then add visible class for animation
    overlay.offsetHeight; // eslint-disable-line no-unused-expressions
    overlay.classList.add('is-visible');

    // Focus trap and close handlers
    var sizeIndex = getStoredFontSize();
    var closeBtn = overlay.querySelector('.jsReaderClose');
    var decreaseBtn = overlay.querySelector('.jsReaderFontDecrease');
    var increaseBtn = overlay.querySelector('.jsReaderFontIncrease');

    closeBtn.addEventListener('click', close);
    closeBtn.focus();

    decreaseBtn.addEventListener('click', function () {
      if (sizeIndex > 0) {
        sizeIndex--;
        updateFontSize(overlay, sizeIndex);
      }
    });

    increaseBtn.addEventListener('click', function () {
      if (sizeIndex < FONT_SIZES.length - 1) {
        sizeIndex++;
        updateFontSize(overlay, sizeIndex);
      }
    });

    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }
    });
  }

  function close() {
    var overlay = document.getElementById('reader-mode-overlay');
    if (!overlay) return;

    overlay.classList.remove('is-visible');
    overlay.addEventListener('transitionend', function handler() {
      overlay.removeEventListener('transitionend', handler);
      overlay.parentNode.removeChild(overlay);
      document.documentElement.style.overflow = '';
      btn.focus();
    });
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    open();
  });
})();
